import type { UserModule } from '~/types'
import { installAPIErrorHandlingInterceptor } from '~/apiErrorHandling'
import { goToUtasApp, resolveUtasOnlyOrgLanding } from '~/managers/utasRedirect'
import { useUserStore } from '~/stores/user'

export const install: UserModule = ({ isClient, router }) => {
  // TODO: Is there a better place for this? It's own module or maybe in main.ts?
  installAPIErrorHandlingInterceptor()
  if (isClient) {
    const userStore = useUserStore()
    router.beforeResolve(async (to, from) => {
      // If we are just moving around the same page, don't do anything
      // TODO: Maybe consider that route changes are not the place to do this anyway?
      // We really want to run all this on page load
      if (from.path === to.path) return
      if (to.meta.auth) {
        if (userStore.authHeader) {
          // Blocks page load until we have user data
          await userStore.loadInfoIfNeeded()
          if (userStore.isUTASOnlyOrg) {
            // UTAS-only orgs belong in the UTAS app. Users with other orgs get an
            // escape so a stale UTAS org can't trap them here (separate origins mean
            // we can't fix it from the UTAS side).
            const outcome = await resolveUtasOnlyOrgLanding(
              userStore.userHasNonUtasOrg
            )
            if (outcome === 'logout') {
              userStore.logout()
              return { name: 'login' }
            }
            goToUtasApp()
            return
          }
        } else {
          // Redirect to login page
          // eslint-disable-next-line no-console
          console.log(
            'Redirecting to login page because no auth header is set',
            to,
            from
          )
          return { name: 'login' }
        }
      }
      userStore.identifyUserWithServices()
    })
  }
}
